var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "60%",
        "max-width": "500",
        value: _vm.lists.show_delete_dialog,
        persistent: "",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "text-h5 primary" }, [
            _vm._v(" Delete Contact "),
          ]),
          _c("v-divider"),
          _c("v-card-text", { staticClass: "py-4" }, [
            _vm._v(" Are you sure you want to delete the list "),
            _c("strong", [_vm._v(_vm._s(_vm.lists.list_to_delete.post_title))]),
            _vm._v(" and all of its contacts? "),
            _vm.error
              ? _c("div", { staticClass: "error--text font-weight-bold" }, [
                  _vm._v("There was an error deleting the list."),
                ])
              : _vm._e(),
          ]),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      _vm.lists.show_delete_dialog = false
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "error",
                    loading: _vm.loading,
                    disabled: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.lists.deleteList(_vm.lists.list_to_delete.ID)
                    },
                  },
                },
                [_vm._v(" Delete ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }